// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BookingModal Component Styles */
.booking-modal__overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.booking-modal__content {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.booking-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 2rem 1rem;
  border-bottom: 1px solid #eee;
}

.booking-modal__header h2 {
  margin: 0;
  color: #2c3e50;
  font-size: 1.5rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 12px;
  letter-spacing: -0.02em;
}

.booking-modal__header h2::before {
  content: '🍽️';
  font-size: 1.5rem;
  filter: grayscale(0.2);
}

.booking-modal__close {
  background: #f8f9fa;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.booking-modal__close:hover {
  background: #e9ecef;
  color: #333;
  transform: rotate(90deg);
}

.booking-modal__close:active {
  transform: rotate(90deg) scale(0.95);
}

.booking-modal__form {
  padding: 2rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #333;
  font-weight: 500;
  font-size: 0.9rem;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 0.875rem 1rem;
  border: 2px solid #e1e5e9;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: #fafbfc;
  color: #2c3e50;
  font-family: inherit;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.form-group input:hover,
.form-group select:hover,
.form-group textarea:hover {
  background: white;
  border-color: #cbd5e0;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #667eea;
  background: white;
  box-shadow:
    0 0 0 4px rgba(102, 126, 234, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

/* Info block */
.booking-info {
  display: flex;
  gap: 12px;
  padding: 1rem;
  background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%);
  border-radius: 10px;
  border-left: 4px solid #667eea;
  margin: 1.5rem 0;
}

.booking-info svg {
  flex-shrink: 0;
  color: #667eea;
  margin-top: 2px;
}

.booking-info p {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #555;
}

/* Spinner */
.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
  margin-right: 8px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.form-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #eee;
}

.btn-primary,
.btn-secondary {
  padding: 0.875rem 2rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  min-width: 140px;
  white-space: nowrap;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  position: relative;
  overflow: hidden;
}

.btn-primary::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s;
}

.btn-primary:hover:not(:disabled)::before {
  left: 100%;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.btn-primary:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
  opacity: 0.6;
}

.btn-secondary {
  background: #f8f9fa;
  color: #666;
  border: 2px solid #e1e5e9;
}

.btn-secondary:hover {
  background: white;
  border-color: #cbd5e0;
  transform: translateY(-1px);
}

/* Адаптивність для мобільних */
@media (max-width: 640px) {
  .booking-modal__content {
    border-radius: 12px;
    max-height: 95vh;
  }

  .booking-modal__header {
    padding: 1.5rem 1.5rem 1rem;
  }

  .booking-modal__header h2 {
    font-size: 1.35rem;
  }

  .booking-modal__form {
    padding: 1.5rem;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 0;
    margin-bottom: 0;
  }

  .form-group {
    margin-bottom: 1.25rem;
  }

  .form-actions {
    flex-direction: column-reverse;
    gap: 0.75rem;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
    padding: 0.875rem 1.25rem;
  }
}

.btn-secondary:hover {
  background: #e9ecef;
  border-color: #ddd;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .booking-modal__overlay {
    padding: 0.5rem;
  }

  .booking-modal__content {
    max-height: 95vh;
  }

  .booking-modal__header,
  .booking-modal__form {
    padding: 1.5rem;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 0;
  }

  .form-actions {
    flex-direction: column-reverse;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
  }
}

/* Status Messages Overlay */
.status-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  border-radius: 16px;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.status-message {
  text-align: center;
  padding: 3rem 2rem;
  max-width: 400px;
  animation: slideUp 0.4s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.status-icon {
  margin: 0 auto 1.5rem;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  animation: scaleIn 0.5s ease 0.2s both;
}

@keyframes scaleIn {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

.status-success .status-icon {
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  color: #2e7d32;
}

.status-error .status-icon {
  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
  color: #c62828;
}

.status-message h3 {
  margin: 0 0 1rem 0;
  font-size: 1.75rem;
  font-weight: 700;
  color: #2c3e50;
}

.status-message p {
  margin: 0 0 1.5rem 0;
  font-size: 1rem;
  line-height: 1.6;
  color: #666;
}

.status-checkmark {
  font-size: 3rem;
  color: #4caf50;
  animation: bounce 0.6s ease 0.4s;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.status-error .btn-primary {
  margin-top: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/BookingModal.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;;;EAGE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB;;gCAE8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,MAAM;IACN,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;IAC9B,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,MAAM;EACR;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* BookingModal Component Styles */\n.booking-modal__overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.booking-modal__content {\n  background: white;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.booking-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2rem 2rem 1rem;\n  border-bottom: 1px solid #eee;\n}\n\n.booking-modal__header h2 {\n  margin: 0;\n  color: #2c3e50;\n  font-size: 1.5rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  letter-spacing: -0.02em;\n}\n\n.booking-modal__header h2::before {\n  content: '🍽️';\n  font-size: 1.5rem;\n  filter: grayscale(0.2);\n}\n\n.booking-modal__close {\n  background: #f8f9fa;\n  border: none;\n  color: #666;\n  cursor: pointer;\n  padding: 0;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n}\n\n.booking-modal__close:hover {\n  background: #e9ecef;\n  color: #333;\n  transform: rotate(90deg);\n}\n\n.booking-modal__close:active {\n  transform: rotate(90deg) scale(0.95);\n}\n\n.booking-modal__form {\n  padding: 2rem;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: #333;\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 0.875rem 1rem;\n  border: 2px solid #e1e5e9;\n  border-radius: 10px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  background: #fafbfc;\n  color: #2c3e50;\n  font-family: inherit;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.form-group input:hover,\n.form-group select:hover,\n.form-group textarea:hover {\n  background: white;\n  border-color: #cbd5e0;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  background: white;\n  box-shadow:\n    0 0 0 4px rgba(102, 126, 234, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.1);\n  transform: translateY(-1px);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n/* Info block */\n.booking-info {\n  display: flex;\n  gap: 12px;\n  padding: 1rem;\n  background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%);\n  border-radius: 10px;\n  border-left: 4px solid #667eea;\n  margin: 1.5rem 0;\n}\n\n.booking-info svg {\n  flex-shrink: 0;\n  color: #667eea;\n  margin-top: 2px;\n}\n\n.booking-info p {\n  margin: 0;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  color: #555;\n}\n\n/* Spinner */\n.spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n  margin-right: 8px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.form-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #eee;\n}\n\n.btn-primary,\n.btn-secondary {\n  padding: 0.875rem 2rem;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n  min-width: 140px;\n  white-space: nowrap;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  position: relative;\n  overflow: hidden;\n}\n\n.btn-primary::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.2),\n    transparent\n  );\n  transition: left 0.5s;\n}\n\n.btn-primary:hover:not(:disabled)::before {\n  left: 100%;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.btn-primary:disabled {\n  background: #cbd5e0;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.btn-secondary {\n  background: #f8f9fa;\n  color: #666;\n  border: 2px solid #e1e5e9;\n}\n\n.btn-secondary:hover {\n  background: white;\n  border-color: #cbd5e0;\n  transform: translateY(-1px);\n}\n\n/* Адаптивність для мобільних */\n@media (max-width: 640px) {\n  .booking-modal__content {\n    border-radius: 12px;\n    max-height: 95vh;\n  }\n\n  .booking-modal__header {\n    padding: 1.5rem 1.5rem 1rem;\n  }\n\n  .booking-modal__header h2 {\n    font-size: 1.35rem;\n  }\n\n  .booking-modal__form {\n    padding: 1.5rem;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n    gap: 0;\n    margin-bottom: 0;\n  }\n\n  .form-group {\n    margin-bottom: 1.25rem;\n  }\n\n  .form-actions {\n    flex-direction: column-reverse;\n    gap: 0.75rem;\n  }\n\n  .btn-primary,\n  .btn-secondary {\n    width: 100%;\n    padding: 0.875rem 1.25rem;\n  }\n}\n\n.btn-secondary:hover {\n  background: #e9ecef;\n  border-color: #ddd;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n  .booking-modal__overlay {\n    padding: 0.5rem;\n  }\n\n  .booking-modal__content {\n    max-height: 95vh;\n  }\n\n  .booking-modal__header,\n  .booking-modal__form {\n    padding: 1.5rem;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n    gap: 0;\n  }\n\n  .form-actions {\n    flex-direction: column-reverse;\n  }\n\n  .btn-primary,\n  .btn-secondary {\n    width: 100%;\n  }\n}\n\n/* Status Messages Overlay */\n.status-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.98);\n  backdrop-filter: blur(10px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n  border-radius: 16px;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.status-message {\n  text-align: center;\n  padding: 3rem 2rem;\n  max-width: 400px;\n  animation: slideUp 0.4s ease;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(30px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.status-icon {\n  margin: 0 auto 1.5rem;\n  width: 80px;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  animation: scaleIn 0.5s ease 0.2s both;\n}\n\n@keyframes scaleIn {\n  from {\n    transform: scale(0);\n  }\n  to {\n    transform: scale(1);\n  }\n}\n\n.status-success .status-icon {\n  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);\n  color: #2e7d32;\n}\n\n.status-error .status-icon {\n  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);\n  color: #c62828;\n}\n\n.status-message h3 {\n  margin: 0 0 1rem 0;\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #2c3e50;\n}\n\n.status-message p {\n  margin: 0 0 1.5rem 0;\n  font-size: 1rem;\n  line-height: 1.6;\n  color: #666;\n}\n\n.status-checkmark {\n  font-size: 3rem;\n  color: #4caf50;\n  animation: bounce 0.6s ease 0.4s;\n}\n\n@keyframes bounce {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n.status-error .btn-primary {\n  margin-top: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
